import React, { useEffect } from 'react';
import { useController, UseControllerProps, useFormContext } from 'react-hook-form';
import { handleMonthInput, MonthPicker } from '@common/datePicker';
import styles from '@components/profile/profileOverlay/overlays/career/career.module.scss';
import { ProfileCareersFormVO } from '@domain/vo/profile/ProfileCareersFormVO';
import { EmploymentStatusType } from '@domain/constant/profile/CareerType';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

type EndDateProps = UseControllerProps & {
  employmentStatus?: EmploymentStatusType;
  readonly?: boolean;
};
const EndDate = (props: EndDateProps) => {
  const { formState } = useFormContext<ProfileCareersFormVO>();
  const { field, fieldState } = useController(props);
  const isEndless = props.employmentStatus !== 'RESIGN';

  useEffect(() => {
    if (isEndless && field.value) field.onChange('');
  }, [props.employmentStatus]);

  const handleChange = (date: Date | null) => {
    if (!date) return;
    field.onChange(DateFormat.format(date, 'yyyy-MM'));
  };

  return (
    <div className={cx('periodWrap')}>
      <MonthPicker
        selected={field.value ? new Date(field.value) : null}
        onChange={handleChange}
        onChangeRaw={handleMonthInput}
        className={cx(
          'periodInput',
          { error: fieldState.invalid },
          { complete: field.value },
          { readonly: props.readonly },
        )}
        placeholderText="연도. 월"
        maxDate={new Date('9999-12')}
        disabled={isEndless}
        readOnly={props.readonly}
      />
      {fieldState.invalid && <div className={cx('errorMessage')}>{formState.errors.endDate?.message}</div>}
    </div>
  );
};

export default EndDate;
